import "@mdi/font/css/materialdesignicons.css";
import Vue from "vue";
import light from "./theme";
import Vuetify, {
    VAlert,
    VApp,
    VNavigationDrawer,
    VFooter,
    VList,
    VBtn,
    VIcon,
    VToolbar,
    VDataTable,
    VProgressLinear,
    VAppBar,
    VBottomNavigation,
    VMain,
} from "vuetify/lib";

// vue-cli a-la-carte installation
Vue.use(Vuetify, {
    components: {
        VAlert,
        VApp,
        VNavigationDrawer,
        VFooter,
        VList,
        VBtn,
        VIcon,
        VToolbar,
        VDataTable,
        VProgressLinear,
        VAppBar,
        VBottomNavigation,
        VMain,
    },
});

const opts = {
    theme: {
        options: { customProperties: true },
        themes: {
            light: {
                ...light,
            },
        },
    },
};

export default new Vuetify(opts);
